import API from "Api";
import { ACTIVITY_LOG_ENDPOINT, STAFF_SEARCH_ENDPOINT } from "Api/endpoints";

export const activityLogAPI = async (token) => {
  return await API.post(ACTIVITY_LOG_ENDPOINT, token);
};

export const staffSearchAPI = async (payload) => {
  return await API.post(STAFF_SEARCH_ENDPOINT, payload);
};